import styled from "styled-components";

export const Background = styled.div`
  min-height: calc(100vh - 80px);
  @media (max-height: 739px) {
    height: 100%;
  }
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  padding: 1rem calc((90vw - 1000px) / 2);
  background-color: #0093e9;
  background-image: linear-gradient(0deg, #0093e9 0%, #99d4f7 50%, #ffffff 100%);
`;

export const Container = styled.div`
  margin: 0;
  width: 100%;
  max-width: 800px;
  height: auto;
  background: #fff;
  padding: 2rem 1rem;
  align-items: center;
  box-shadow: 0px 3px 12px -3px rgba(0, 0, 0, 0.5);
  border-radius: 0.5rem;
  min-width: 89px;
`;

export const ContentWrapper = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 1rem;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const Panel = styled.div`
  flex: 1;
  padding: 1rem;
  border: 1px solid #eee;
  border-radius: 0.5rem;
`;

export const Hr = styled.div`
  background-color: #0093e9;
  height: 0.19rem;
  width: 100%;
  margin-top: 15px;
`;

export const Button = styled.button`
  margin-right: 5px;
  width: 100px;
  height: 30px;
  border-radius: 4px;
  background: #2b74e0;
  color: #fff;
  border: 2px;
  outline: none;
  cursor: pointer;

  text-decoration: none;
  text-align: center;
  transition: linear 0.2s;
  &:hover {
    background-color: #1563cf;
  }
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;

  th,
  td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: left;
  }

  th {
    background-color: #f2f2f2;
  }

  tr:nth-child(even) {
    background-color: #f9f9f9;
  }
`;

export const ButtonAdd = styled.button`
  width: 25px;
  height: 25px;
  border-radius: 4px;
  background: #2b74e0;
  color: #fff;
  border: none;
  outline: none;
  cursor: pointer;
  text-decoration: none;
  text-align: center;
  transition: linear 0.2s;
  margin-top: 2px;

  &:hover {
    background-color: #1563cf;
  }
`;

export const Titulo = styled.h1`
  color: #0093e9;
  text-align: center;

  @media (max-width: 550px) {
    font-size: 28px;
  }
`;

export const H4 = styled.h4`
  font-weight: normal;
  padding: 0 5px;
`;

export const P = styled.p`
  margin-bottom: 8px;
`;

export const BigButton = styled.button`
  width: 140px;
  height: 45px;
  border-radius: 4px;
  background: #2b74e0;
  color: #fff;
  border: 2px;
  outline: none;
  cursor: pointer;
  margin-left: auto;
  font-weight: bold;
  font-size: 17px;
  text-decoration: none;
  text-align: center;
  transition: linear 0.2s;
  &:hover {
    background-color: #1563cf;
  }
`;

export const Icone = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
`;

export const Circle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  font-size: 48px;
  color: #fff;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: ${(props) => (props.success ? "green" : "red")};
`;
export const InputLabel = styled.div`
  display: flex;
  flex-direction: column;
  margin: 5px 20px 0 20px;
  label {
    text-align: center;
    margin-right: 15px;
    font-size: 16px;
    margin-left: 5px;
  }

  input {
    height: 30px;
    width: 100%;
    border-radius: 5px;
    text-align: center;
    padding: 3px 7px;
  }
`;
